import getConfig from '@/config'

export const getDashboardURL = subpath =>
  `${getConfig().publicRuntimeConfig.dashUrl}/${subpath.replace(/^\/+/, '')}`

export const getImageURL = (size, bucket, path) =>
  `${getConfig().publicRuntimeConfig.imagesUrl}/${bucket}/${size}/${path}`

export const getFullURL = subpath =>
  `${getConfig().publicRuntimeConfig.mainSiteUrl}/${subpath.replace(/^\/+/, '')}`
